import {Col, message, Row, Spin} from "antd";
import {useEffect, useState} from "react";
import adminService from "../../../service/adminService";
import {MSG_FAILED_TO_FETCH_JOINT_ACCOUNT_TEMPLATE_REQUEST_LIST_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import '../styles.scss';
import JointAccountTemplateRequestTable
    from "../../../components/admin/jointAccountTemplateRequest/jointAccountTemplateRequestTable";
import {JointAccountTemplateAdminDto} from "../../../dto/admin/JointAccountTemplateAdminDto";
import {UsergroupAddOutlined} from "@ant-design/icons";


const JointAccountTemplateRequest = () => {
    const [pendingList, setPendingList] = useState<JointAccountTemplateAdminDto[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getDetailVerificationPendingList();
    }, [])

    const getDetailVerificationPendingList = () => {
        setIsLoading(true)
        adminService.getPendingJointAccountTemplateRequests().then(res => {
            if (res.data !== null) {
                setPendingList(res.data.results)
                setIsLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_JOINT_ACCOUNT_TEMPLATE_REQUEST_LIST_ERROR).then();
                setIsLoading(false)

            }
        }, (reason) => {
            setIsLoading(false)
            ErrorHandler.handleError(reason);
        })
    }

    const tableUpdateFunc = (data: boolean) => {
        getDetailVerificationPendingList()
        // setTableUpdate(data)
    }

    return (
        <Spin spinning={isLoading}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'>
                        <div className='header_icon header-icon-center'>
                            <UsergroupAddOutlined/>
                        </div>
                        Joint Account Template Requests
                    </h2>
                </Col>
            </Row>
            <Row gutter={[16, 16]} className='margin_top_30'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <JointAccountTemplateRequestTable tableUpdateFunc={tableUpdateFunc}
                                                      tableData={pendingList}/>
                </Col>
            </Row>


        </Spin>


    )

}
export default JointAccountTemplateRequest;

